import { Pipe, PipeTransform } from '@angular/core';

import { formatSystemDate } from '../utils/system-date.util';

// Impuro de propósito: o deslocamento do servidor é carregado de forma assíncrona na inicialização,
// e o pipe precisa se atualizar quando ele chegar depois da primeira renderização.
@Pipe({ name: 'systemDate', pure: false })
export class SystemDatePipe implements PipeTransform {
  transform(value: string | Date | null | undefined, format = 'dd/MM/yyyy'): string | null {
    return formatSystemDate(value, format);
  }
}
